var _style, _path, _g, _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCholineDeficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B72555;}\n\t.st1{fill:#F4DBCC;}\n\t.st2{fill:#DEA993;}\n\t.st3{opacity:0;clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.3,67c-4.1-3.9-8.6-6.2-12.9-6.3c-14.2-0.2-30.8,23.8-31.2,47.6c0,2.5,0.1,4.8,0.4,7.1 c2.4,19.5,15.7,31.2,29.3,31.4c15.2,0.3,30.6-13.7,31-37.4C136.2,92.7,128.7,75.8,119.3,67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.3,67c7.2,9,12.5,23,12.3,36.8c-0.4,22.8-15,36.2-29.3,35.9c-11.5-0.2-22.8-9.1-26.7-24.4 c2.4,19.5,15.7,31.2,29.3,31.4c15.2,0.3,30.6-13.7,31-37.4C136.2,92.7,128.7,75.8,119.3,67"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 111.9,
    cy: 78.8,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 108.8,
    cy: 67.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 118.6,
    cy: 81.8,
    r: 1.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCholineDeficiency);
export default __webpack_public_path__ + "static/media/Choline_Deficiency.465b73b385751ac8971ec8225ee9ee6d.svg";
export { ForwardRef as ReactComponent };